import React, { useState, useEffect } from "react";
import CandidateAvatar from "../Avatars/CandidateAvatar";
import "../../css/chats.css";
import { SingleMessageType } from "../../interfaces/chats";
import dayjs from "dayjs";
import { useAppSelector } from "../../store/store";
import { isEmpty } from "lodash";
import moment from "moment";
import { getMessageTimestamp } from "../../functions/commons";

interface ToMessagePropType {
  chat: SingleMessageType;
}

function ToMessage(props: ToMessagePropType) {
  const { chat } = props;
  const { profileData } = useAppSelector((state) => state["user"]);

  return (
    <>
      <div className="r2cmc-to-and-from-msgs__to-msg-div">
        <div style={{ width: "85%", textAlign: "right" }}>
          <span>{getMessageTimestamp(chat.createdAt)}</span>
        </div>
        <div className="tafm-to-msg-div__img-msg">
          <div
            className="message-content-details"
            style={{ height: "fit-content" }}
          >
            <h5>{chat.content} </h5>
          </div>
          {isEmpty(profileData?.candidate?.profilePicture) ? (
            <CandidateAvatar />
          ) : (
            <img src={profileData?.candidate?.profilePicture} />
          )}
        </div>
      </div>
    </>
  );
}

export default ToMessage;
